export const OBJECT_HOMEWORK_STATUS = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  GRADED: 'GRADED',
  DRAFT: 'DRAFT'
}

export enum HOMEWORK_STATUS {
  NEW = 'NEW',
  SEEN = 'SEEN',
  GRADED = 'GRADED',
  DRAFT = 'DRAFT',
  FEEDBACK_DRAFT = 'FEEDBACK_DRAFT',
  FINISHED = 'FINISHED'
}

export enum HOMEWORK_HISTORY_STATUS {
  RESPONSE = 'RESPONSE',
  FEEDBACK = 'FEEDBACK'
}

export const HOMEWORK_STATUS_ICON: any = {
  ICON_NEW: '',
  ICON_SEEN: 'clipboard-solid',
  ICON_GRADED: 'clipboard-check-solid',
  ICON_FEEDBACK_DRAFT: 'firstdraft'
}

export const TEACHER_HOMEWORK_STATUS_ICON: any = {
  DRAFT: 'user-edit',
  FEEDBACK_DRAFT: 'edit-message'
};

export const GRADING_SCALES: any = {
  CUSTOM: 'CUSTOM',
  PERCENTAGE: 'PERCENTAGE',
  POINTS: 'POINTS',
  PASS_FAIL: 'PASS_FAIL',
  LETTER: 'LETTER'
};

export const GRADING_EVENTS: any = {
  VALIDATE_GRADE: 'validateGrade'
}

export const HOMEWORK_SOCKET_EVENTS = {
  connect: '/app/interactive/tasks.connect',
  join: '/app/interactive/tasks.join',
  leave: '/app/interactive/tasks.leave',
  changePage:  '/app/interactive/tasks.changePage',
  response: '/interactive/topic/{username}',
  classTasksTopic: '/interactive/topic/{classId}/tasks',
  taskTopic: '/interactive/topic/task/{taskId}'
}

export const HOMEWORK_SOCKET_MESSAGES_TYPES = {
  studentConnect: 'STUDENT_CONNECT',
  teacherConnect: 'TEACHER_CONNECT',
  guestConnect: 'GUEST_CONNECT',
  leave: 'LEAVE',
  taskUsersOnline: 'TASK_USERS_ONLINE',
  usersOnTask: 'USERS_ON_TASK',
  changePage: 'CHANGE_PAGE'
}



export const HOMEWORKS_EVENTS = {
  LOAD_STUDENT_HOMEWORKS_TEACHER_WIDGET: 'LOAD_STUDENT_HOMEWORKS_TEACHER_WIDGET',
  LOAD_SECTION_TEACHER_WIDGET: 'LOAD_SECTION_TEACHER_WIDGET',
  OPEN_SEND_RESPONSE_HOMEWORK: 'OPEN_SEND_RESPONSE_HOMEWORK',
  SEND_FEEDBACK_TO_STUDENT: 'SEND_FEEDBACK_TO_STUDENT',
  UPDATE_HOMEWORK_STATUS: 'UPDATE_HOMEWORK_STATUS',
  HOMEWORK_VIEWER_IS_CLOSED: 'HOMEWORK_VIEWER_IS_CLOSED',
  RELOAD_STUDENT_HOMEWORKS_TEACHER_WIDGET: 'RELOAD_STUDENT_HOMEWORKS_TEACHER_WIDGET',
  RELOAD_SECTION_TEACHER_WIDGET: 'RELOAD_SECTION_TEACHER_WIDGET',
  REALOAD_TEACHER_HOMEWORKS: 'REALOAD_TEACHER_HOMEWORKS',
  REALOAD_TEACHER_HOMEWORKS_FEEDBACK: 'REALOAD_TEACHER_HOMEWORKS_FEEDBACK',
  RELOAD_TASKS_BY_SECTIONS_TAB: 'RELOAD_TASKS_BY_SECTIONS_TAB',
  WHITEBOARD_CLOSED_ON_DELETE: 'WHITEBOARD_CLOSED_ON_DELETE',
  CHANGE_SPLIT_TAB: 'CHANGE_SPLIT_TAB',
  USER_JOINED_OR_LEFT_HOMEWORK: 'USER_JOINED_OR_LEFT_HOMEWORK',
  COLLABORATIVE_USER_CHANGED_PAGE: 'COLLABORATIVE_USER_CHANGED_PAGE',
  OPEN_HOMEWORK_SNAPSHOT: 'OPEN_HOMEWORK_SNAPSHOT'
}

export enum TEACHER_WIDGET_TASK_TABS {
  BY_STUDENT = 'BY_STUDENT',
  BY_SECTIONS = 'BY_SECTIONS'
}

export const PAGE_SIZE = 10;

export const HOMEWORKS_STORE_NAME = 'HomeworksStore';

export const HOMEWORKS_API = {
  CREATE_HOMEWORK: 'homework/upload',
  CREATE_DRAFT_HOMEWORK: 'homework/upload/draft',
  UPDATE_HOMEWORK: 'homework/upload/{homeworkId}',
  GET_COURSES_HOMEWORKS_BY_TEACHER: 'homework/byteacher/courses',
  GET_HOMEWORKS_FROM_CLASS: '{classId}/courses',
  GET_STUDENTS_WITH_HOMEWORKS_FROM_COURSE: 'homework/{classId}/students/{contentId}',
  GET_STUDENT_HOMEWORKS_FROM_TEACHER_WIDGET: 'homework/{classId}/content/{contentId}/student/{studentId}',
  GET_SECTIONS_HOMEWORKS_FROM_TEACHER_WIDGET: 'homework/{classId}/content/{contentId}/section/{sectionId}',
  SET_TEACHER_HOMEWORK_STATUS_FEEDBACK_DRAFT: 'homework/{homeworkId}/feedbackDraft',
  SET_TEACHER_HOMEWORK_STATUS_SEEN: 'homework/{homeworkId}/statusSeen',
  SET_TEACHER_HOMEWORK_STATUS_FINISHED: '/api/homework/{homeworkId}/finish',
  SET_TEACHER_HOMEWORK_GRADE: 'homework/{homeworkId}/grade?grade={grade}',
  GET_COURSES_HOMEWORKS_BY_STUDENT: 'homework/bystudent/courses',
  GET_STUDENT_PENDING_HOMEWORKS: 'homework/{classId}/content/{contentId}/mypendings',
  FINISH_HOMEWORK: 'homework/{homeworkId}/finish',
  GET_TEACHER_SECTIONS_FROM_COURSE_HOMEWORK: 'homework/{classId}/content/{contentId}/sections',
  SET_FEEDBACK_DRAFT: 'homework/upload/feedbackDraft',
  FINISH_WHITEBOARD_HOMEWORK: 'boards',
  GET_STUDENT_HOMEWORKS_ALL_FROM_TEACHER_WIDGET: 'homework/{classId}/content/{contentId}/student/{studentId}/all',
  OBTAIN_STUDENT_WHITEBOARD_HOMEWORK_HASH: 'homework/board/student',
  OBTAIN_TEACHER_WHITEBOARD_HOMEWORK_HASH: 'homework/board/teacher',
  OBTAIN_WHITEBOARD_HOMEWORK_FEEDBACK_HASH: 'homework/board/feedback/{homeworkId}',
  SEND_WHITEBOARD_FEEDBACK: 'homework/board/feedback/{homeworkId}',
  REGISTRY_WHITEBOARD_SOCKET: 'homework/board/presence',
  OBTAIN_CURRENT_WHITEBOARD_USERS: 'homework/board/{boardGroup}/users',
  OBTAIN_USERS_MADE_ANNOTATIONS: 'homework/board/{boardGroup}/usersMadeAnnotations',
  ADD_BOARD_PAGE: 'homework/board/newPage',
  OBTAIN_BOARD_UPDATES: 'homework/board/{boardGroup}/page/{pageNumber}',
  GET_CURRENT_HOMEWORK_DRAFT: 'homework/section/{sectionId}/student/{studentId}/draftAssetInfo',
  GET_CURRENT_HOMEWORK_CONVERTER_STATUS: 'homework/homework/response/canBeOpen/{hash}',
  GET_HOMEWORK_SCALE: 'homework/{homeworkId}/gradingScale',
  GET_HOMEWORK_BY_SECTION_STUDENT: 'homework/class/{classId}/content/{contentId}/section/{sectionId}/student/{studentId}',
  GET_HOMEWORK_STATUS: 'homework/{homeworkId}/status',
  GET_HOMEWORK_STATUS_BY_STUDENTS: 'homework/status',
  GET_HOMEWORK_BOARD_PAGES: 'homework/board/{boardGroup}/allPages',
  OBTAIN_BOARD_ANNOTATIONS: 'homework/board/{boardGroup}/annotations',
  UPDATE_BOARD_ANNOTATIONS: 'homework/board/draft',
  UPDATE_FEEDBACK_BOARD_ANNOTATIONS: 'homework/board/feedback/draft',
  GET_BOARD_CURRENT_VERSION: 'homework/board/{boardGroup}/version',
  GET_HOMEWORK_HISTORY: 'homework/history/{classId}/{sectionId}/{studentId}/{type}',
  GET_HOMEWORK_HISTORY_ANNOTATIONS: 'homework/history/{historyId}/annotations',
  GET_HOMEWORK_HISTORY_BOARD_PAGES: 'homework/history/{historyId}/allPages',
  RECOVER_HOMEWORK_HISTORY: 'homework/history/{historyId}/recover',
  GET_HOMEWORK_HISTORY_TEXT_DRAFT: 'homework/history/{historyId}/textDraft?sectionId={sectionId}&studentId={studentId}&classId={classId}',
  GET_HOMEWORK_TEXT_DRAFT_INFO: 'homework/text/draft/class/{classId}/section/{sectionId}/student/{studentId}',
  GET_CONSOLIDATED_HOMEWORKS_BY_CLASS:'homework/{classId}/content/{contentId}/consolidate',
  GENERATE_CONSOLIDATED_HOMEWORKS: 'homework/{classId}/content/{contentId}/student/{studentId}/consolidate?includeFeedback={includeFeedback}&includeProblem={includeProblem}'
}

export const ACTIONS = {
  GET_TEACHER_WIDGET_HOMEWORKS: 'getTeacherWidgetHomeworks',
  GET_TEACHER_WIDGET_HOMEWORKS_BY_SECTIONS: 'getTeacherWidgetHomeworksBySections',
  GET_STUDENTS_WITH_HOMEWORKS_FROM_COURSE: 'getStudentsWithHomeworksFromCourse',
  SELECT_WIDGET_TEACHER_PERSON_SELECTED: 'selectWidgetTeacherPersonSelected',
  SELECT_WIDGET_TEACHER_SECTION_SELECTED: 'selectWidgetTeacherSectionSelected',
  SEND_FEEDBACK_TO_STUDENT: 'sendFeedbackToStudent',
  UPDATE_TEACHER_HOMEWORK_STATUS: 'updateTeacherHomeworkStatus',
  SET_TEACHER_HOMEWORK_GRADE: 'setTeacherHomeworkGrade',
  GET_COURSES_HOMEWORKS_BY_STUDENT: 'getCoursesHomeworksByStudent',
  GET_STUDENT_PENDING_HOMEWORKS: 'getStudentPendingHomeworks',
  SET_STUDENT_HOMEWORK_RESPONSE: 'setStudentHomeworkResponse',
  GET_SECTIONS_WITH_STUDENTS_FROM_COURSE: 'getSectionsWithStudentsFromCourse',
  SET_HOMEWORK_SOLVED: 'setHomeworkSolved',
  GET_TEACHER_SECTIONS_FROM_COURSE_HOMEWORK: 'getTeacherSectionsFromCourseHomework',
  SET_DRAFT_HOMEWORK: 'setDraftHomework',
  SET_FEEDBACK_DRAFT: 'setFeedbackDraft',
  SELECT_WIDGET_TEACHER_PERSON_SELECTED_ALL: 'selectWidgetTeacherPersonSelectedAll',
  FILL_HOMEWORK_BOARD_USERS: 'fillHomeworkBoardUsers',
  UPDATE_WIDGET_TEACHER_PERSON_SELECTED_ALL: 'updateWidgetTeacherPersonSelectedAll',
  GET_HOMEWORK_CONVERTER_STATUS: 'getHomeworkConverterStatus',
  GET_HOMEWORK_SCALE: 'getHomeworkScale',
  OBTAIN_SECTION_HOMEWORK: 'obtainSectionHomework',
  OBTAIN_STUDENTS_HOMEWORK_STATUS: 'obtainStudentsHomeworkStatus'
}

export const MUTATIONS = {
  SET_TEACHER_WIDGET_HOMEWORKS: 'setTeacherWidgetHomeworks',
  SET_TEACHER_WIDGET_HOMEWORKS_SECTIONS: 'setTeacherWidgetHomeworksSections',
  SET_STUDENTS_WITH_HOMEWORKS_IN_COURSE: 'setStudentsWithHomeworksInCourse',
  UPDATE_WIDGET_TEACHER_CLASS: 'updateWidgetTeacherClass',
  UPDATE_WIDGET_TEACHER_COURSE: 'updateWidgetTeacherCourse',
  UPDATE_WIDGET_TEACHER_COURSE_SECTION: 'updateWidgetTeacherCourseSection',
  SELECT_WIDGET_TEACHER_PERSON: 'selectWidgetTeacherPerson',
  SELECT_WIDGET_TEACHER_SECTION: 'selectWidgetTeacherSection',
  SET_WIDGET_TEACHER_PERSON_SELECTED: 'setWidgetTeacherPersonSelected',
  SET_WIDGET_TEACHER_SECTION_SELECTED: 'setWidgetTeacherSectionSelected',
  UPDATE_WIDGET_TEACHER_PERSON: 'updateWidgetTeacherPerson',
  UPDATE_RESPONSE_WIDGET_TEACHER_SECTION: 'updateResponseWidgetTeacherSection',
  SET_STUDENT_COURSES_HOMEWORKS: 'setStudentCoursesHomeworks',
  SET_STUDENT_HOMEWORKS_IN_COURSES: 'setStudentHomeworksInCourses',
  UPDATE_STUDENT_COURSES_HOMEWORKS: 'updateStudentCoursesHomeworks',
  UPDATE_COURSE_HOMEWORKS: 'updateCourseHomeworks',
  REMOVE_STUDENT_HOMEWORK: 'removeStudentHomework',
  OPEN_WIDGET_TEACHER_COURSE: 'openWidgetTeacherCourse',
  SET_TEACHER_WIDGET_TAB_SELECTED: 'setTeacherWidgetTabSelected',
  OPEN_WIDGET_TEACHER_COURSE_SECTION: 'openWidgetTeacherCourseSection',
  SET_SECTIONS_IN_COURSE_HOMEWORK: 'setSectionsInCourseHomework',
  CHANGE_CONFIRM_CLOSE_HOMEWORK_VIEWER: 'changeConfirmCloseHomeworkViewer',
  UPDATE_STUDENT_HOMEWORK_DRAFT: 'updateStudentHomeworkDraft',
  SET_FEEDBACK_DRAFT_IN_HOMEWORK: 'setFeedbackDraftInHomework',
  SET_TEACHER_HOMEWORK_STATUS: 'setTeacherHomeworkStatus',
  REFRESH_PERSON_STATUS: 'refreshPersonStatus',
  ADD_BOARD_HOMEWORK_HASH_USERS: 'addBoardHomeworkHashUsers',
  ADD_BOARD_STUDENT_HOMEWORKS_HASH_USERS: 'addBoardStudentHomeworksHashUsers',
  REMOVE_BOARD_HOMEWORK_HASH_USERS: 'removeBoardHomeworkHashUsers',
  UDPATE_WIDGET_TEACHER_COURSE_SECTION_STATUS: 'updateWidgetTeacherCourseSectionStatus',
  SET_LIST_ID_TO_RELOAD: 'setListIdsToReload',
  REDUCE_LIST_ID_TO_RELOAD: 'reduceListIdsToReload',
  UPDATE_BOARD_ANNOTATIONS: 'updateBoardAnnotation',
  CLEAR_UNDO_BOARD_ANNOTATIONS: 'clearUndoBoardAnnotations',
  CLEAR_REDO_BOARD_ANNOTATIONS: 'clearRedoBoardAnnotations',
  UPDATE_NUMBER_PAGES: 'updateNumberPages',
  REMOVE_LAST_BOARD_ACTION_ANNOTATION: 'removeLastBoardActionAnnotation',
  INIT: 'init',
  ADD_PRESENTATION_SECTION_CONTENT: 'addPresentationSectionContent',
  CLEAR_PRESENTATION_SECTION_CONTENT: 'clearPresentationSectionContent',
  UPDATE_SELETED_BOARD_INFO: 'updateSelectedBoardInfo',
  UPDATE_HOMEWORK_SECTION_IS_SENT: 'updateHomeworkSectionIsSent',
  RESET_ONLINE_HOMEWORK_DATA: 'resetOnlineHomeworkData',
  INIT_ONLINE_HOMEWORK_DATA: 'initOnlineHomeworkData',
  UPDATE_ONLINE_HOMEWORK_DATA: 'updateOnlineHomeworkData',
  UPDATE_ONLINE_HOMEWORK_PAGE: 'updateOnlineHomeworkPage',
  UPDATE_ONLINE_HOMEWORK_USERS_COLLABORATING: 'updateOnlineHomeworkUsersCollaborating',
  UPDATE_SAVING_HOMEWORK: 'updateSavingHomework',
  UPDATE_SAVING_DRAFT: 'updateSavingDraft',
  SET_BOARD_PARAMETERS: 'setBoardParameters',
  SET_TASK_BOARD_PARAMETERS: 'setBoardParameters',
  SET_BOARD_ACTIVE: 'setBoardActive',
  SET_EDUPAD_ACTIVE: 'setEdupadActive',
  SET_SYNCHRONISING_EDUPAD: 'setSynchronisingEdupad',
  SET_CLIENT_ID: 'setClientId',
  SET_CURSOR_BOARD_ACTIVE : 'setCursorBoardActive'
}

export const _HOMEWORKS_STORE = {
  NAME: HOMEWORKS_STORE_NAME,
  MUTATIONS: {
    SET_TEACHER_WIDGET_HOMEWORKS: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_TEACHER_WIDGET_HOMEWORKS}`,
    SET_TEACHER_WIDGET_HOMEWORKS_SECTIONS: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_TEACHER_WIDGET_HOMEWORKS_SECTIONS}`,
    SET_STUDENTS_WITH_HOMEWORKS_IN_COURSE: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_STUDENTS_WITH_HOMEWORKS_IN_COURSE}`,
    UPDATE_WIDGET_TEACHER_CLASS: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_WIDGET_TEACHER_CLASS}`,
    UPDATE_WIDGET_TEACHER_COURSE: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_WIDGET_TEACHER_COURSE}`,
    UPDATE_WIDGET_TEACHER_COURSE_SECTION: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_WIDGET_TEACHER_COURSE_SECTION}`,
    SELECT_WIDGET_TEACHER_PERSON: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SELECT_WIDGET_TEACHER_PERSON}`,
    SELECT_WIDGET_TEACHER_SECTION: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SELECT_WIDGET_TEACHER_SECTION}`,
    SET_WIDGET_TEACHER_PERSON_SELECTED: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_WIDGET_TEACHER_PERSON_SELECTED}`,
    SET_WIDGET_TEACHER_SECTION_SELECTED: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_WIDGET_TEACHER_SECTION_SELECTED}`,
    UPDATE_WIDGET_TEACHER_PERSON: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_WIDGET_TEACHER_PERSON}`,
    UPDATE_RESPONSE_WIDGET_TEACHER_SECTION: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_RESPONSE_WIDGET_TEACHER_SECTION}`,
    SET_STUDENT_HOMEWORKS_IN_COURSES: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_STUDENT_HOMEWORKS_IN_COURSES}`,
    UPDATE_COURSE_HOMEWORKS: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_COURSE_HOMEWORKS}`,
    REMOVE_STUDENT_HOMEWORK: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.REMOVE_STUDENT_HOMEWORK}`,
    OPEN_WIDGET_TEACHER_COURSE: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.OPEN_WIDGET_TEACHER_COURSE}`,
    SET_TEACHER_WIDGET_TAB_SELECTED: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_TEACHER_WIDGET_TAB_SELECTED}`,
    OPEN_WIDGET_TEACHER_COURSE_SECTION: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.OPEN_WIDGET_TEACHER_COURSE_SECTION}`,
    SET_SECTIONS_IN_COURSE_HOMEWORK: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_SECTIONS_IN_COURSE_HOMEWORK}`,
    CHANGE_CONFIRM_CLOSE_HOMEWORK_VIEWER: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.CHANGE_CONFIRM_CLOSE_HOMEWORK_VIEWER}`,
    UPDATE_STUDENT_HOMEWORK_DRAFT: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_STUDENT_HOMEWORK_DRAFT}`,
    SET_FEEDBACK_DRAFT_IN_HOMEWORK: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_FEEDBACK_DRAFT_IN_HOMEWORK}`,
    SET_TEACHER_HOMEWORK_STATUS: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_TEACHER_HOMEWORK_STATUS}`,
    REFRESH_PERSON_STATUS: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.REFRESH_PERSON_STATUS}`,
    ADD_BOARD_HOMEWORK_HASH_USERS: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.ADD_BOARD_HOMEWORK_HASH_USERS}`,
    ADD_BOARD_STUDENT_HOMEWORKS_HASH_USERS: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.ADD_BOARD_STUDENT_HOMEWORKS_HASH_USERS}`,
    REMOVE_BOARD_HOMEWORK_HASH_USERS: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.REMOVE_BOARD_HOMEWORK_HASH_USERS}`,
    UDPATE_WIDGET_TEACHER_COURSE_SECTION_STATUS: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UDPATE_WIDGET_TEACHER_COURSE_SECTION_STATUS}`,
    SET_LIST_ID_TO_RELOAD: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_LIST_ID_TO_RELOAD}`,
    REDUCE_LIST_ID_TO_RELOAD: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.REDUCE_LIST_ID_TO_RELOAD}`,
    UPDATE_BOARD_ANNOTATIONS: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_BOARD_ANNOTATIONS}`,
    CLEAR_UNDO_BOARD_ANNOTATIONS: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.CLEAR_UNDO_BOARD_ANNOTATIONS}`,
    CLEAR_REDO_BOARD_ANNOTATIONS: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.CLEAR_REDO_BOARD_ANNOTATIONS}`,
    UPDATE_NUMBER_PAGES: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_NUMBER_PAGES}`,
    REMOVE_LAST_BOARD_ACTION_ANNOTATION: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.REMOVE_LAST_BOARD_ACTION_ANNOTATION}`,
    INIT: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.INIT}`,
    ADD_PRESENTATION_SECTION_CONTENT: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.ADD_PRESENTATION_SECTION_CONTENT}`,
    CLEAR_PRESENTATION_SECTION_CONTENT: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.CLEAR_PRESENTATION_SECTION_CONTENT}`,
    UPDATE_SELETED_BOARD_INFO: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_SELETED_BOARD_INFO}`,
    UPDATE_HOMEWORK_SECTION_IS_SENT: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_HOMEWORK_SECTION_IS_SENT}`,
    RESET_ONLINE_HOMEWORK_DATA: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.RESET_ONLINE_HOMEWORK_DATA}`,
    INIT_ONLINE_HOMEWORK_DATA: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.INIT_ONLINE_HOMEWORK_DATA}`,
    UPDATE_ONLINE_HOMEWORK_DATA: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_ONLINE_HOMEWORK_DATA}`,
    UPDATE_ONLINE_HOMEWORK_PAGE: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_ONLINE_HOMEWORK_PAGE}`,
    UPDATE_ONLINE_HOMEWORK_USERS_COLLABORATING: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_ONLINE_HOMEWORK_USERS_COLLABORATING}`,
    UPDATE_SAVING_HOMEWORK: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_SAVING_HOMEWORK}`,
    UPDATE_SAVING_DRAFT: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.UPDATE_SAVING_DRAFT}`,
    SET_BOARD_PARAMETERS:  `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_BOARD_PARAMETERS}`,
    SET_TASK_BOARD_PARAMETERS:  `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_BOARD_PARAMETERS}`,
    SET_BOARD_ACTIVE: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_BOARD_ACTIVE}`,
    SET_EDUPAD_ACTIVE: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_EDUPAD_ACTIVE}`,
    SET_SYNCHRONISING_EDUPAD: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_SYNCHRONISING_EDUPAD}`,
    SET_CLIENT_ID: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_CLIENT_ID}`,
    SET_CURSOR_BOARD_ACTIVE: `${HOMEWORKS_STORE_NAME}/${MUTATIONS.SET_CURSOR_BOARD_ACTIVE}`,
  },
  ACTIONS: {
    GET_TEACHER_WIDGET_HOMEWORKS: `${HOMEWORKS_STORE_NAME}/${ACTIONS.GET_TEACHER_WIDGET_HOMEWORKS}`,
    GET_TEACHER_WIDGET_HOMEWORKS_BY_SECTIONS: `${HOMEWORKS_STORE_NAME}/${ACTIONS.GET_TEACHER_WIDGET_HOMEWORKS_BY_SECTIONS}`,
    GET_STUDENTS_WITH_HOMEWORKS_FROM_COURSE: `${HOMEWORKS_STORE_NAME}/${ACTIONS.GET_STUDENTS_WITH_HOMEWORKS_FROM_COURSE}`,
    SELECT_WIDGET_TEACHER_PERSON_SELECTED: `${HOMEWORKS_STORE_NAME}/${ACTIONS.SELECT_WIDGET_TEACHER_PERSON_SELECTED}`,
    SELECT_WIDGET_TEACHER_SECTION_SELECTED: `${HOMEWORKS_STORE_NAME}/${ACTIONS.SELECT_WIDGET_TEACHER_SECTION_SELECTED}`,
    SEND_FEEDBACK_TO_STUDENT: `${HOMEWORKS_STORE_NAME}/${ACTIONS.SEND_FEEDBACK_TO_STUDENT}`,
    UPDATE_TEACHER_HOMEWORK_STATUS: `${HOMEWORKS_STORE_NAME}/${ACTIONS.UPDATE_TEACHER_HOMEWORK_STATUS}`,
    SET_TEACHER_HOMEWORK_GRADE: `${HOMEWORKS_STORE_NAME}/${ACTIONS.SET_TEACHER_HOMEWORK_GRADE}`,
    GET_COURSES_HOMEWORKS_BY_STUDENT: `${HOMEWORKS_STORE_NAME}/${ACTIONS.GET_COURSES_HOMEWORKS_BY_STUDENT}`,
    GET_STUDENT_PENDING_HOMEWORKS: `${HOMEWORKS_STORE_NAME}/${ACTIONS.GET_STUDENT_PENDING_HOMEWORKS}`,
    SET_STUDENT_HOMEWORK_RESPONSE: `${HOMEWORKS_STORE_NAME}/${ACTIONS.SET_STUDENT_HOMEWORK_RESPONSE}`,
    GET_SECTIONS_WITH_STUDENTS_FROM_COURSE: `${HOMEWORKS_STORE_NAME}/${ACTIONS.GET_SECTIONS_WITH_STUDENTS_FROM_COURSE}`,
    SET_HOMEWORK_SOLVED: `${HOMEWORKS_STORE_NAME}/${ACTIONS.SET_HOMEWORK_SOLVED}`,
    GET_TEACHER_SECTIONS_FROM_COURSE_HOMEWORK: `${HOMEWORKS_STORE_NAME}/${ACTIONS.GET_TEACHER_SECTIONS_FROM_COURSE_HOMEWORK}`,
    SET_DRAFT_HOMEWORK: `${HOMEWORKS_STORE_NAME}/${ACTIONS.SET_DRAFT_HOMEWORK}`,
    SET_FEEDBACK_DRAFT: `${HOMEWORKS_STORE_NAME}/${ACTIONS.SET_FEEDBACK_DRAFT}`,
    SELECT_WIDGET_TEACHER_PERSON_SELECTED_ALL: `${HOMEWORKS_STORE_NAME}/${ACTIONS.SELECT_WIDGET_TEACHER_PERSON_SELECTED_ALL}`,
    FILL_HOMEWORK_BOARD_USERS: `${HOMEWORKS_STORE_NAME}/${ACTIONS.FILL_HOMEWORK_BOARD_USERS}`,
    UPDATE_WIDGET_TEACHER_PERSON_SELECTED_ALL: `${HOMEWORKS_STORE_NAME}/${ACTIONS.UPDATE_WIDGET_TEACHER_PERSON_SELECTED_ALL}`,
    GET_HOMEWORK_CONVERTER_STATUS: `${HOMEWORKS_STORE_NAME}/${ACTIONS.GET_HOMEWORK_CONVERTER_STATUS}`,
    GET_HOMEWORK_SCALE: `${HOMEWORKS_STORE_NAME}/${ACTIONS.GET_HOMEWORK_SCALE}`,
    OBTAIN_SECTION_HOMEWORK: `${HOMEWORKS_STORE_NAME}/${ACTIONS.OBTAIN_SECTION_HOMEWORK}`,
    OBTAIN_STUDENTS_HOMEWORK_STATUS: `${HOMEWORKS_STORE_NAME}/${ACTIONS.OBTAIN_STUDENTS_HOMEWORK_STATUS}`
  }
}

export const HOMEWORK_KEYS = {
  RESPONSE_STUDENT: 'response'
};

export const SHOW_RESPONSE_TABS : string[] = ['ResponseTab', 'SplitVertical', 'SplitHorizontal'];
